// production
const config = {
  baseUrl: "https://fleets-demo.cabcard.services",
  apiBaseUrl: "https://ccs-fleets-demo-api.herokuapp.com",
  apiKey: "fBrL6zASe3j7ESZJ3MaebqzerPRcOhXK",
  cookieDomain: "fleets-demo.cabcard.services",
  namespace: "fleets-demo_cabcard-services"
};

if (window.location.hostname === "localhost") {
  // development
  config.baseUrl = `http://${window.location.host}`;
  config.apiBaseUrl = "http://localhost:3000";
  config.apiKey = "wzaILy2jtT1p2Nwz9PHRodiIMUnR19ua";
  config.cookieDomain = "localhost";
}

export default config;
